import { useFormContext, useWatch } from 'react-hook-form';

import type { Content } from '@/entities/content/api/types';
import Player from '@/widgets/player';

export function SlidesPlayerWrapper() {
  const { control } = useFormContext<Content>();

  const slides = useWatch({ control, name: 'slides' });
  const config = useWatch({ control, name: 'config' });

  return (
    <Player
      type="slider"
      content={{
        config,
        slides,
      }}
      resetHLS
    />
  );
}
